import React from "react";
import SendSticker from "../../Components/Tracking/SendSticker";
// import LeftMenu from "../../Components/LeftMenu";
import queryString from "query-string";

const SendStickerPage = ({ match, location }) => {
  const query = queryString.parse(location.search);

  return (
    <React.Fragment>
      {/* <LeftMenu /> */}
      <SendSticker date={query.date} />
    </React.Fragment>
  );
};

export default SendStickerPage;
